<template>
  <div id="dashboard">
    <!-- <Breadcrumb :list="list"/> -->
    <div v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
        <datecomponent ref="datecomponent"></datecomponent>
        <div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
        <div class="datebox">
          <button class="btn btn-block weavrpurple" @click="createPdf">Download</button>
        </div>
        <div class="datebox" style="min-width:17% ">
          <p class="channel-title">Channel:</p>
          <select @change="refresh" v-model="channelSelector" class="form-control">
            <option value="">All </option>
            <option value="amazon">Amazon </option>
            <option value="flipkart">Flipkart </option>
            <!-- <option value="walmart">Walmart </option>
            <option value="BESTBUY">Best Buy </option>
            <option value="jd">JD</option>
            <option value="costco">Costco </option>
            <option value="hp">HP </option> -->
          </select>
        </div>
      </div>  
    </div>  

    <div class="container-fluid" id="dashboardPdf">
      <h3 class="cust-head">Total Reviews </h3>
      <div >
        <b-row>
          <b-col class="custCols" sm="6" lg="4" v-for="(ud, i) in products" :key="i">
            <div data-html2canvas-ignore="true" style="margin:0 1px 6px 1px">
              <select @change="changeProduct"  v-model="selectedProducts[i]" class="form-control text-uppercase">
                <optgroup label="Primary">
                  <option v-for="d in primaryProductsOptions" :value="d.product_name">{{ d.product_name }}</option>
                </optgroup>
                <optgroup label="Competitor">
                  <option v-for="d in nonPrimaryProductsOptions" :value="d.product_name">{{ d.product_name }}</option>
                </optgroup> 
              </select>
            </div>  
            <b-card no-body class="bg-info" :style="'background-color:' + ud.color + '!important;border-color:'+ud.color"> 
              <b-card-body class="pb-0">
                <h4 class="mb-0">
                  <span >{{ reviewCountMapper[ud.product_name] | format }}</span></h4>
                <p class="text-capitalize">{{ ud.product_name }} </p>
              </b-card-body>
              <!-- <card-line2-chart-example chartId="card-chart-02" class="chart-wrapper px-3" style="height:70px;" :height="70" :brand="ud.brand"/> -->
            </b-card>
          </b-col>  
        </b-row>
        <h3 class="cust-head">Ratings </h3>
        <b-row>
          <b-col class="custCols" sm="6" lg="4" v-for="(ud,i) in products" :key="i">
            <b-card v-if="ratingMapper[ud.product_name]">
              <h5 class="cust-head text-capitalize">
                <span >{{ ud.product_name }}</span>
                <i class="fa fa-star text-star-color float-right"></i>
                <span class="float-right">{{ ratingMapper[ud.product_name].review_avg | format }}</span>
              </h5>
              <div class="progress-group" v-for="r in ratingMapper[ud.product_name].ratings">
                <div class="progress-group-header">
                  <i class="fa fa-star text-star-color" v-for="s in r.rating"></i>
                  <span class="ml-auto "> {{ r.count | format }}
                    <span class="text-muted small">({{ r.per | format }}%)</span>
                  </span>
                </div>  
                <div class="progress-group-bars">
                  <div class="progress progress-xs">
                    <div role="progressbar" class="progress-bar" :class="'card_'+ud.brand_name" :style="'width:' + r.per +'%'">
                    </div>
                  </div>
                </div>
              </div>
            </b-card>  
          </b-col>
        </b-row> 
        <b-card>
          <b-row>
            <b-col sm="5">
              <h4 id="traffic" class="card-title mb-0">Number of reviews</h4>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="mr-3  radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <highcharts :options="charts.review_count" v-if="activeChart"></highcharts>
          <div v-if="!activeChart"> No Data</div>
        </b-card>
        <b-card>
          <b-row>
            <b-col sm="5">
              <h4 id="traffic" class="card-title mb-0">Average review rank</h4>
             
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
                  <b-form-radio class="mx-0"  value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0"  value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0"  value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <!--highchart-->
          <highcharts :options="charts.rating" v-if="activeChart"></highcharts>
          <div v-if="!activeChart"> No Data</div>
        </b-card>
        <h3 class="cust-head">Voice of Customers </h3>
        <b-card>
          <b-row>
            <b-col sm="5">
              <highcharts v-if="data.length"  :options="charts.circlular" />
              <div v-if="!data.length">No data</div>
            </b-col>
            <b-col sm="7">
              <highcharts v-if="data.length" :options="charts.stackgraph" /> 
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
  
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import moment from 'moment'
import datecomponent from './date.vue'
import Loader from './Components/Loader.vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent,
    Loader
  },

  data: function () {
    return {
      promises: [],
      selected: 'day',
      data: [],
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
      customData: JSON.parse(localStorage.getItem('reviewCustomData')),
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],
      reviewCountMapper: {},
      ratingMapper: {},
      dateDropDown: 'custom',
      credits: false,
      loader: true,
      channelSelector: '',
      activeChart: false,
      charts: {
        circlular: {},
        stackgraph: {},
      },
      date:{}
    }
  },
  watch:
  {
    'selected':function(){
      this.getChartData()
    }
  },
  mounted()
  {
    this.products = this.customData.products 
    this.nonPrimaryProductsOptions = this.customData.nonPrimaryProductOptions
    this.primaryProductsOptions = this.customData.primaryProductOptions
    this.selectedProducts = this.customData.selectedProducts
    this.refresh()
  },
  methods: {
    createPdf(){
      let self = this
      self.loader = true
      let content = document.querySelector("#dashboardPdf")
      let canvasWidth = content.scrollWidth + 5
      let canvasHeight = content.scrollHeight + 5
      let options = {
        scale: 1.5,
        width: canvasWidth,
        onclone:function(){
          alert('Pdf generated. Download Now')
        }
      }
      setTimeout(function(){
        html2canvas(content,options).then(canvas => {
          let imgData = canvas.toDataURL("image/jpeg",1.0);
          let doc = new jsPDF('p', 'mm', [canvasWidth,canvasHeight])
          let pdfWidth = canvasWidth - 16;
          let pdfHeight = canvasHeight;
          doc.addImage(imgData,'JPEG',8,8,pdfWidth,pdfHeight)
          doc.save('voc_weavr_dashboard_' + moment().format("DDMMMYYYY") + '.pdf')
          self.loader = false
        })
      },0)
    },

    changeProduct(){
      let self = this
      self.products = []
      for(let [pi, pdata] of this.selectedProducts.entries()) {
        for(let [ci, cdata] of this.userData.products.entries()) {
          if (pdata == cdata.product_name)
          {
            self.products.push(cdata)
          }
        }  
      }
      self.refresh()
    },
    processUserData()
    {
      
     
    },
    drawStackChart(){
      let self = this
      let dataNeutral = []
      let dataPositive = []
      let dataNegative = []
      let category = []
      for (let [i, k] of this.data.entries()) {
        category.push(k.product_name.toUpperCase())
        dataNeutral.push(k.rating_sentiment['neutral'].count)
        dataPositive.push(k.rating_sentiment['positive'].count)
        dataNegative.push(k.rating_sentiment['negative'].count)
      }    
      this.charts.stackgraph = {
        chart: {
          type: 'column',
          height:220, 
        },
        title: {
          text: ''
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: category
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 10,
          title: {
            text: ''
          },
          stackLabels: {
            enabled: false,
          }
        },
        tooltip: {
          formatter(){
            var mytooltip = this.point.category + '<br/>'
            mytooltip += '<span style="color:' + this.point.series.color + '">\u25CF</span> '
            mytooltip += this.point.series.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage)  + '%)</b> <br/>'
            mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
            return mytooltip;             
          },
        },
        plotOptions: {
          column: {
            stacking: 'percent',
            borderWidth: 0,
            dataLabels: {
              enabled: false
            }
          }
        },
        series: [{
          name: 'Neutral',
          data: dataNeutral,
          color: 'silver'
        }, {
          name: 'Positive',
          data: dataPositive,
          color: 'green'
        }, {
          name: 'Negative',
          data: dataNegative,
          color: 'red'
        }]
      }
    },
    drawCircularChart(){
      let self = this
      let series = [] 
      for (let [i, k] of this.data.entries()) 
      {
        for(let [idx, dataset] of this.userData.products.entries())
        {
          if(dataset.product_name == k.product_name )
          {
            let data = {}
            data.name = k.product_name.toUpperCase()
            data.y = k.count
            // data.color = dataset.color
            series.push(data)
          }
        }
      }    
      this.charts.circlular =
      {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin:[0,0,0,0],
          padding:[0,0,0,0],
          height:220,
        },
        title: {  
            text: '',
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
              valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(){
            var mytooltip = ''
            mytooltip += '<span style="color:' + this.point.series.color + '">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + ' (' + self.format(this.point.percentage)  + '%)</b> <br/>'
            mytooltip += 'Total: <b>' + self.format(this.point.total) + '</b>'
            return mytooltip;             
          },
        },
        plotOptions: {
            series: {
                borderWidth: 0,
            },
            pie: {
                dataLabels: {
                  enabled: true,
                  distance: -15,
                  format: '{point.percentage:.1f} %',
                  style: {
                    fontSize: 10   
                  }  
                },
                showInLegend: true,
                startAngle: -180,
                endAngle: 180,
                center: ['50%', '37%'],
                size: '74%'
            }
        },
        legend:{
          itemStyle: {
            fontSize: 9,
          }
        },  
        series: [{  
          type: 'pie',
          innerSize: '50%',
          data: series
        }]
      }  
    },
    format(v)
    {
      return this.$options.filters.format(v)
    },
   
    refresh(){
      this.date = this.$refs.datecomponent.date
      this.getData()   
      this.getChartData()
    },
    getData()
    {
      this.loader = true
      const url = "/api/reviews/bulk?channel="+ this.channelSelector +"&start_date="+this.date.startDate+"&end_date="+this.date.endDate+"&interval="+this.selected + "&products=" + this.selectedProducts
      this.$http.get(url).then(response => {
        this.data = response.body.data
        this.loader = false
        this.createReviewCountMapper()
        this.drawCircularChart()
        this.drawStackChart()
      }, err => {
        this.loader = false
      });
    },
    createReviewCountMapper(){
      this.reviewCountMapper = {}
      this.ratingMapper = {}
      for(let [idx, dataset] of this.data.entries()) 
      {
        this.$set(this.reviewCountMapper, dataset.product_name, dataset.count )
        this.$set(this.ratingMapper, dataset.product_name, dataset )
      }
    },
    plotChart(d){
      var self = this
      this.charts[d.key] = 
      {
        credits: {
          enabled: false
        },
        chart: {
          
        },
        title: {
          text: ''
        },
        subtitle: {
            text: ''
        },

        yAxis: {
            title: {
                text: ''
            }
        },
        xAxis:{
          categories: d.category,
          crosshair: true,
          crosshair:{
            color: 'rgba(166, 215, 238)',
            width:2,
          } 
        },
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y) + '</b> <br/>';
            }
            return mytooltip;
          },
          shared: true
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9 
            }
          }
        },
        series: d.series
      }
    },
    processChartData(data,key){
      let category = []
      let series = []
      for(let [idx, dataset] of this.products.entries()) 
      {
        for (let [i, k] of data.entries())
        {
          if(dataset.product_name == k.product_name )  
          {
            let obj = {}
            obj.name =  k.product_name.toUpperCase()
            obj.data = []    
            // obj.color = dataset.color
            for(let [j,x] of k.timeline.entries())
            {
              obj.data.push(x[key])
              if (i==0)
              {
                category.push(x['date'])
              }
            } 
            series.push(obj)
            break
          }  
        }
      }  
      this.plotChart({ key: key, series: series, category: category })
    },
    getChartData(){
      this.loader = true
      this.activeChart = false
      const url = "/api/reviews/histogram?channel="+ this.channelSelector +"&start_date="+this.date.startDate+"&end_date="+this.date.endDate+"&interval="+this.selected + "&products=" + this.selectedProducts
      this.$http.get(url).then(response => {
        let gKeys = Object.keys(response.body.data[0].timeline[0])
        for (let [idx,key] of gKeys.entries())
        {
          if (key != 'date')
          {
            this.charts[key] = {}
            this.processChartData(response.body.data,key)
          }
        }
        this.activeChart = true
        this.loader = false
      }, err => {
        this.loader = false
      });
    }
  }
}


</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .card_vivo
  {
    background-color: #0072ba !important;
    border: 1px solid #0072ba !important;
  }
  .card_realme
  {
    background-color: #f3b821 !important;
    border: 1px solid #f3b821 !important;
  }
  .card_redmi
  {
    background-color: #f56628 !important; 
    border: 1px solid #f56628 !important;
  }


</style>
